// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a1e13423","455":"e6faed1f","977":"99319339"}[chunkId] + ".chunk.js";
};